/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Modal, Button, message, Tag, Avatar, Popover } from "antd";
import { FlagFilled, LoadingOutlined } from "@ant-design/icons";
import "./index.css";
import {
  FacebookShareButton,
  WhatsappShareButton,
  TwitterShareButton,
} from "react-share";
import { FacebookIcon, WhatsappIcon, TwitterIcon } from "react-share";

// ACTIONS
import {
  programDetails,
  programDetailsCleanup,
} from "../../Store/actions/programDetails";
import { addFlag, addFlagCleanup } from "../../Store/actions/flagging/addFlag";
import {
  deleteFlag,
  deleteFlagCleanup,
} from "../../Store/actions/flagging/deleteFlag";
import fromhome from "../../Assets/images/fromhome.png";
import { useAppDispatch, useAppSelector } from "../../hooks";
import CartButton from "../../Components/CartButton";
import { selectLoggedInUser } from "../../Store/actions/getMe";
import { formatCurrency } from "../../Utils";
import { CartItemDetail } from "../Private/common/cart";

const ProgramDetails: React.FC = () => {
  const { _id } = useParams();
  const dispatch = useAppDispatch();
  const programState = useAppSelector((s) => s.programDetails);
  const authState = useAppSelector((state) => state.auth);
  const addFlagState = useAppSelector((state) => state.addFlag);
  const deleteFlagState = useAppSelector((state) => state.deleteFlag);
  const currentUser = useAppSelector(selectLoggedInUser);

  const [programs, setPrograms] = useState<any>({});
  const [programId, setProgramId] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [flagMessage, setFlagMessage] = useState("");

  const states = Array.from(
    new Set(programs?.products?.map((p: any) => p?.item?.state))
  );

  const flagProgram = () => {
    const msg = {
      message: flagMessage,
    };

    dispatch(addFlag({ programId, msg }));
  };

  const removeFlag = () => {
    dispatch(deleteFlag({ programId }));
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  useEffect(() => {
    if (!currentUser?.data) {
      // history.push("/login");
    }
  }, [currentUser?.data]);

  useEffect(() => {
    dispatch(programDetails({ _id }));
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (programState.isSuccessful) {
      setPrograms(programState.data);
      setProgramId(programState.data._id);

      dispatch(programDetailsCleanup());
    } else if (programState.error) {
      setPrograms(null);
      dispatch(programDetailsCleanup());
    }
  }, [programState]);

  useEffect(() => {
    if (addFlagState.isSuccessful) {
      setIsModalVisible(false);
      message.success("You have flagged this program");
      dispatch(programDetails({ _id }));
      dispatch(addFlagCleanup());
      setFlagMessage("");
    } else if (addFlagState.error) {
      dispatch(addFlagCleanup());
      message.error("Something went wrong, Try again later");
    }
  }, [addFlagState]);

  useEffect(() => {
    if (deleteFlagState.isSuccessful) {
      message.info("you have removed the flag from this program");
      dispatch(programDetails({ _id }));
      dispatch(deleteFlagCleanup());
    } else if (deleteFlagState.error) {
      message.error("Something went wrong, Try again later");
      dispatch(deleteFlagCleanup());
    }
  }, [deleteFlagState]);

  return (
    <div className="program-details">
      {programState.isLoading ? (
        <div
          className="justify-content-center w-100 program-detail-top"
          style={{ minHeight: "40vh" }}
        >
          <LoadingOutlined style={{ fontSize: 30 }} spin />
        </div>
      ) : (
        <>
          {programs?.products?.length > 0 && (
            <>
              <div className="program-detail-top">
                <div>
                  <div
                    className="program_image_container"
                    style={{
                      backgroundImage: `url(${
                        programs?.avatar?.secure_url ?? fromhome
                      })`,
                    }}
                  />
                </div>

                <div>
                  <h6 className="title">{programs.title}</h6>

                  <div className="state__wrapper text-start">
                    <h4 className="state__title">State:</h4>

                    {!!states?.length ? (
                      <div className="state__list d-flex flex-wrap align-items-center">
                        {states?.map((state, key) => (
                          <Tag key={key} style={{ padding: "8px" }}>
                            {state}
                          </Tag>
                        ))}
                      </div>
                    ) : null}
                  </div>

                  <div className="state__wrapper text-start">
                    <h4 className="state__title">Products:</h4>
                    <Avatar.Group>
                      {programs?.products?.slice(0, 4)?.map((p) => (
                        <CartItemDetail key={p._id} {...p} />
                      ))}
                    </Avatar.Group>
                  </div>

                  <div className="program-detail-info">
                    <p>
                      In stock:
                      <span>{programs.stock}</span>
                    </p>
                    <p>
                      No of Products:
                      <span>
                        {programs?.products?.reduce((p, c) => p + c.stock, 0)}
                      </span>
                    </p>

                    <p>
                      Original Price:
                      <span>
                        {formatCurrency(programs?.totalSellingPrice ?? 0)}
                      </span>
                    </p>

                    <p>
                      saving:
                      <span>
                        {formatCurrency(programs?.totalDiscount ?? 0)}
                      </span>
                    </p>
                    <p>
                      <span className="action-btns">
                        <span className="share-btn">
                          <FacebookShareButton url={window.location.href}>
                            <FacebookIcon size={32} round />
                          </FacebookShareButton>

                          <WhatsappShareButton url={window.location.href}>
                            <WhatsappIcon size={32} round />
                          </WhatsappShareButton>

                          <TwitterShareButton url={window.location.href}>
                            <TwitterIcon size={32} round />
                          </TwitterShareButton>
                        </span>
                      </span>
                    </p>

                    {authState?.isLoggedIn ? (
                      <p>
                        {(() => {
                          if (programs.flag === false) {
                            return (
                              <button
                                className="flag-btn"
                                onClick={() => showModal()}
                              >
                                <FlagFilled
                                  style={{
                                    color: "rgb(84, 84, 84)",
                                    fontSize: "15px",
                                  }}
                                />
                                <span
                                  className="mx-2 fw-bold"
                                  style={{ fontSize: "12px" }}
                                >
                                  Flag
                                </span>
                              </button>
                            );
                          }
                          if (programs.flag && programs.youFlagged) {
                            return (
                              <button
                                className="flag-btn"
                                onClick={() => removeFlag()}
                              >
                                <FlagFilled
                                  style={{
                                    color: "#cc0404",
                                    fontSize: "15px",
                                  }}
                                />
                                <span
                                  className="mx-2 fw-bold"
                                  style={{ fontSize: "12px" }}
                                >
                                  Remove flag
                                </span>
                              </button>
                            );
                          }
                          if (programs.flag && programs.youFlagged === false) {
                            return (
                              <button
                                className="flag-btn"
                                onClick={() => showModal()}
                              >
                                <FlagFilled
                                  style={{
                                    color: "#c7c402",
                                    fontSize: "15px",
                                  }}
                                />
                                <span
                                  className="mx-2 fw-bold"
                                  style={{ fontSize: "12px" }}
                                >
                                  flag program
                                </span>
                              </button>
                            );
                          }
                        })()}
                      </p>
                    ) : null}
                  </div>

                  <div className="buy-btn-container mt-2">
                    <CartButton program_id={programs._id} />
                  </div>
                </div>
              </div>

              <div className="program-detail-bottom mt-5">
                {/* <div className="program__list">
                  {programs.products.map((product) => (
                    <ProgramCardDetail key={product?._id} product={product} />
                  ))}
                </div> */}
                {/* <Row xs="12" md="3" lg="4">
                  {programs.products &&
                    programs.products.map((product) => (
                      <Col
                        key={product._id}
                        className="col"
                        style={{ marginBottom: "20px" }}
                      >
                        <Link to={`/products/${product?.item?._id}`}>
                          <Card className="product_card">
                            <div className="m-3">
                              <Image
                                src={product?.item?.avatar?.secure_url || ""}
                                crossOrigin="anonymous"
                                width={"100%"}
                                preview={false}
                                fallback="data:image/png;base64,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"
                              />
                            </div>

                            <CardBody>
                              <h4 className="product-title">
                                {product?.item?.title}
                                <span> ({product?.item?.category}) </span>
                              </h4>
                              <p className="total-discount">
                                ${product?.item?.sellingPrice}.00
                              </p>
                              <p className="total-price">
                                ${product?.item?.price}.00
                              </p>
                            </CardBody>
                          </Card>
                        </Link>
                      </Col>
                    ))}
                </Row> */}
              </div>
            </>
          )}
        </>
      )}

      <Modal
        title="Reason for flagging this program"
        open={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
      >
        <textarea
          className="w-100 px-2"
          rows={5}
          value={flagMessage}
          onChange={(e) => setFlagMessage(e.target.value)}
        ></textarea>

        <Button
          disabled={flagMessage === ""}
          type="primary"
          className="mt-4"
          onClick={() => flagProgram()}
        >
          {addFlagState.isLoading ? (
            <LoadingOutlined style={{ fontSize: 20, color: "#000000" }} spin />
          ) : (
            <span>Report</span>
          )}
        </Button>
      </Modal>
    </div>
  );
};

export default ProgramDetails;
